import { MomentAdapter } from 'utils/date/momentAdapter';

const parseLogInfo = ({ updatedAt, updatedBy }) => ({
  updatedAt: MomentAdapter.formatLocal(updatedAt, 'MM/DD/YYYY hh:mm A'),
  updatedBy: `${updatedBy.firstName} ${updatedBy.lastName}`,
});

export { parseLogInfo };
